import { consumptionAPI, consumptionPublic } from "./clients";

const END_POINT = "/console";

const getConsoleData = data => {
  return consumptionAPI.post(END_POINT, data);
};

const getConsoleMeta = dashboard_id => {
  return consumptionAPI.get(`/dashboards/${dashboard_id}`);
};

const getRawConsoleData = dashboard_id => {
  return consumptionAPI.get(`/dashboards/${dashboard_id}/details`);
};

/**
 * Edpoint to access dashboardMeta without access token
 * @param {String} magic_link
 */
const getPublicConsoleData = magic_link => {
  return consumptionPublic.get(`/dashboards/public/${magic_link}`);
};

export {
  getConsoleData,
  getConsoleMeta,
  getRawConsoleData,
  getPublicConsoleData,
};
